/* OWR card carousel — image slider inside product cards, site-wide.
   Delegated events only: no per-card initialisation.
   Includes tap-vs-swipe detection so a clean tap on a slide opens the
   product while swipes/arrow clicks never navigate. */
(function () {
  'use strict';

  function slideWidth(track) {
    var slide = track.querySelector('.owr-cc__slide');
    return slide ? slide.getBoundingClientRect().width : track.clientWidth;
  }

  /* ---------- arrows: delegated ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.owr-cc__arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var cc = btn.closest('.owr-cc');
    var track = cc && cc.querySelector('.owr-cc__track');
    if (!track) return;
    var dir = btn.classList.contains('owr-cc__arrow--next') ? 1 : -1;
    var w = slideWidth(track);
    var max = track.scrollWidth - track.clientWidth;
    var target = track.scrollLeft + dir * w;
    if (target > max + 2) target = 0;
    if (target < -2) target = max;
    track.scrollTo({ left: target, behavior: 'smooth' });
  });

  /* ---------- dots: one capture-phase scroll listener ---------- */
  var pending = new Set();
  var scheduled = false;

  function syncDots(track) {
    var cc = track.closest('.owr-cc');
    if (!cc) return;
    var dots = cc.querySelectorAll('.owr-cc__dot');
    if (!dots.length) return;
    var idx = Math.round(track.scrollLeft / Math.max(1, slideWidth(track)));
    idx = Math.max(0, Math.min(dots.length - 1, idx));
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i === idx);
    });
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.classList || !t.classList.contains('owr-cc__track')) return;
      pending.add(t);
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        pending.forEach(syncDots);
        pending.clear();
        scheduled = false;
      });
    },
    true
  );

  /* ---------- keyboard support on focused track ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var track = e.target.closest && e.target.closest('.owr-cc__track');
    if (!track) return;
    e.preventDefault();
    var dir = e.key === 'ArrowRight' ? 1 : -1;
    track.scrollBy({ left: dir * slideWidth(track), behavior: 'smooth' });
  });

  /* ---------- tap on a slide opens the product; swipes don't ---------- */
  var downX = 0;
  var downY = 0;
  var downScroll = 0;

  document.addEventListener('pointerdown', function (e) {
    var track = e.target.closest && e.target.closest('.owr-cc__track');
    if (!track) return;
    downX = e.clientX;
    downY = e.clientY;
    downScroll = track.scrollLeft;
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.owr-cc__arrow')) return;
    var track = e.target.closest && e.target.closest('.owr-cc__track');
    if (!track) return;
    var moved =
      Math.abs(e.clientX - downX) > 8 ||
      Math.abs(e.clientY - downY) > 8 ||
      Math.abs(track.scrollLeft - downScroll) > 4;
    if (moved) return;
    var card = track.closest('.card-wrapper');
    var link = card && card.querySelector('.card__heading a');
    if (link && link.href) window.location.href = link.href;
  });
})();